import type { ITableParams, ITableDataState, ITableState } from '~/types/table';

export const INITIAL_DATA_STATE: ITableDataState<never> = {
  data: [] as never[],
  isLoading: false,
  isSuccessful: false,
  isError: false
};

export const INITIAL_TABLE_PARAMS: ITableParams = {
  orderBy: null,
  sort: 0,
  pagination: {
    current: 1,
    pageSize: 100,
    total: 0,
    showSizeChanger: true
  }
};

type InitialTableConfig = {
  orderBy?: string | null;
  pageSize?: number;
};

export const createInitialTableState = <T>({
  orderBy = null,
  pageSize = INITIAL_TABLE_PARAMS.pagination.pageSize
}: InitialTableConfig = {}): ITableState<T> => ({
  ...INITIAL_DATA_STATE,
  tableParams: {
    ...INITIAL_TABLE_PARAMS,
    orderBy,
    pagination: {
      ...INITIAL_TABLE_PARAMS.pagination,
      pageSize
    }
  }
});
